import {
  FiledClaimStatusSumaryUiModel,
  FiledClaimUiModel,
} from "../models/filed-case-ui.model";
import { FiledCaseResponseAPI } from "../models/filed-case.response-api.model";
import { UnclaimCasesResponseApiModel } from "../models/unclaim-cases-response-api";
import {
  TypeSumary,
  ProviderBreakdown,
  UnClaimUiModel,
} from "../models/unclaim-cases-ui.model";

function resolveProviderAmountPotential(
  provider: UnclaimCasesResponseApiModel["providerBreakdown"][string],
): number {
  return provider.unclaimedCasesAmountPotential ?? 0;
}

function resolveBreakdownAmountPotential(entry: {
  amountPotential?: number;
}): number {
  return entry.amountPotential ?? 0;
}

export function mapUnClaimResponseToUIModel(
  response: UnclaimCasesResponseApiModel
): UnClaimUiModel {
  if (!response || !response.providerBreakdown) {
    return {
      unClaimProviderBreakdownUIModel: [],
      summary: {
        unclaimedCasesTotal: 0,
        unclaimedCasesAmount: 0,
        typeSummary: {},
      },
    };
  }
  const typeSummary: TypeSumary = {};
  let totalUnclaimedCases = 0;
  let totalUnclaimedAmount = 0;

  const unClaimProviderBreakdownUIModel: ProviderBreakdown[] = Object.entries(
    response.providerBreakdown
  ).map(([providerName, provider]) => {
    totalUnclaimedCases += provider.unclaimedCasesTotal;
    totalUnclaimedAmount += resolveProviderAmountPotential(provider);

    const claimTypeBreakdown = Object.entries(provider.claimTypeBreakdown).map(
      ([claimTypeKey, claim]) => {
        const amount = resolveBreakdownAmountPotential(claim);
        if (
          claimTypeKey !== "Lost_Inbound" &&
          claimTypeKey !== "Lost_Outbound"
        ) {
          if (!typeSummary[claimTypeKey]) {
            typeSummary[claimTypeKey] = { total: 0, amount: 0 };
          }
          typeSummary[claimTypeKey].total += claim.total;
          typeSummary[claimTypeKey].amount += amount;
        }

        return {
          typeName: claimTypeKey,
          total: claim.total,
          amount,
        };
      }
    );

    const statusBreakdown = Object.entries(provider.statusBreakdown).map(
      ([statusKey, status]) => ({
        statusName: statusKey,
        total: status.total,
        amount: resolveBreakdownAmountPotential(status),
      })
    );

    return {
      providerName,
      unclaimedCasesTotal: provider.unclaimedCasesTotal,
      unclaimedCasesAmount: resolveProviderAmountPotential(provider),
      claimTypeBreakdown,
      statusBreakdown,
    };
  });

  return {
    unClaimProviderBreakdownUIModel,
    summary: {
      unclaimedCasesTotal: totalUnclaimedCases,
      unclaimedCasesAmount: totalUnclaimedAmount,
      typeSummary: typeSummary,
    },
  };
}
